import React, { useEffect, useState } from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
  withRouter,
} from 'react-router-dom';
import { Menu } from 'antd';
import { SpTab } from 'components/DesignKit';

import RatesList from './components/RatesList';
import IssuerRatesList from './components/IssuerRatesList';
import ExchangeRatesList from './components/ExchangeRatesList';

type Props = {
  location: {
    pathname: string
  },
};

const Rates = (props: Props) => {
  const [current, setCurrent] = useState('acquirer');
  const { path } = useRouteMatch();
  const {
    location,
  } = props;

  const setMenu = (query) => {
    switch (query) {
      case '/rate': {
        setCurrent('acquirer');
        break;
      }
      case '/rate/issuerrate': {
        setCurrent('issuerrate');
        break;
      }
      case '/rate/exchangerate': {
        setCurrent('exchangerate');
        break;
      }
      default:
        setCurrent('acquirer');
    }
  };

  useEffect(() => {
    const { pathname } = location;
    setMenu(pathname);
  }, [location]);

  return (
    <div>
      <Menu onClick={e => setCurrent(e.key)} selectedKeys={[current]} mode="horizontal" style={{ fontSize: '20px' }}>
        <Menu.Item key="acquirer">
          <SpTab
            to={path}
            selected={current === 'acquirer'}
          >
            Acquirer Rates
          </SpTab>
        </Menu.Item>
        <Menu.Item key="issuerrate">
          <SpTab
            to={`${path}/issuerrate`}
            selected={current === 'issuerrate'}
          >
            Issuer Rates
          </SpTab>
        </Menu.Item>
        <Menu.Item key="exchangerate">
          <SpTab
            to={`${path}/exchangerate`}
            selected={current === 'exchangerate'}
          >
            Exchange Rates
          </SpTab>
        </Menu.Item>
      </Menu>

      <Switch>
        <Route path={path} component={RatesList} />
        <Route exact path={`${path}/issuerrate`} component={IssuerRatesList} />
        <Route exact path={`${path}/exchangerate`} component={ExchangeRatesList} />
      </Switch>
    </div>
  );
};

export default withRouter(Rates);
